// Supabase restituisce al massimo 1000 righe per richiesta: oltre, i dati spariscono senza errori.
// fetchAll legge a pagine finche' ci sono righe. makeQuery deve creare ogni volta una query NUOVA
// con un ordinamento stabile, altrimenti le pagine possono sovrapporsi.
const PAGE = 1000

export async function fetchAll(makeQuery) {
  let all = []
  for (let from = 0; ; from += PAGE) {
    const { data, error } = await makeQuery().range(from, from + PAGE - 1)
    if (error) return { data: all, error }
    all = all.concat(data || [])
    if (!data || data.length < PAGE) return { data: all, error: null }
  }
}
